import { useTheme } from '@mui/material';
import { useCurrentBreakpoint } from 'hooks/useCurrentBreakpoint';

export const useIsMobile = () => {
  const cb = useCurrentBreakpoint();
  const theme = useTheme();

  return theme.breakpoints.values[cb] < theme.breakpoints.values['laptop'];
};
